export const SALE = "sale";
export const RENTAL = "rental";
